/* eslint-disable array-callback-return */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import { useEffect, useState, useRef } from 'react';
import { Tabs, Tab, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import arrowUp from '../../../assets/images/svg/arrow-up-white.svg';
import { SimpleButton } from '../../button';
import './topicFilter.css';

function TopicsFilter() {
  const [alphabates] = useState([
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z'
  ]);
  const [keyForTabs, setKeyForTabs] = useState('');
  const [diseases] = useState([
    'Abdominal Pain',
    'Acne',
    'ADHD',
    'Allergies',
    'Antibiotics',
    'Anxiety',
    'Appendicitis',
    'Aromatherapy',
    'Arrhythmia',
    'Arthritis',
    'Asthma',
    'Autism',
    'Autoimmune Disorders',
    'Back Pain',
    'Bipolar Disorder',
    'Birth Defects',
    'Blood Cell Disorders',
    'Brain Disorders',
    'Breast Cancer',
    'Bug Bites',
    'Burns',
    'Cavities',
    'Chest Pain',
    'Chlamydia',
    'Chron’s Disease',
    'Chronic Fatigue Syndrome (CFS)',
    'Cocaine',
    'Common Cold',
    'Constipation',
    'COPD',
    'Coronary Artery Disease',
    'COVID-19',
    'Depression Diabetes',
    'Diet Types',
    'Digestive Problems',
    'Dizziness',
    'Diarrhea',
    'Drug Abuse'
  ]);
  const [dictionary, setDictionary] = useState(new Map());

  // sort all diseases based on first letter
  // link diseases with letters
  useEffect(() => {
    const sortedDiseases = diseases.sort();

    let i = 0;
    alphabates.map((alphabet) => {
      if (!dictionary.has(alphabet)) {
        dictionary.set(alphabet, []);
      }

      for (; i < sortedDiseases.length; i += 1) {
        const disease = sortedDiseases[i];
        if (disease?.toLowerCase().indexOf(alphabet) === 0) {
          dictionary.get(alphabet).push(sortedDiseases[i]);
        } else {
          return;
        }
      }

      if (dictionary.get(alphabet).length === 0) {
        dictionary.delete(alphabet);
      }
    });

    setDictionary(dictionary);
    setKeyForTabs('sehat');
  }, []);

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);

  const ForTop = useRef(null);
  const ForLetter = useRef(null);
  const executeScrollForTop = () => scrollToRef(ForTop);
  const executeScrollForLetter = () => scrollToRef(ForLetter);

  return (
    <section className="topicFilter" ref={ForTop}>
      <Container>
        <Tabs
          id="controlled-tab-speciality"
          activeKey={keyForTabs}
          transition
          onSelect={(k) => setKeyForTabs(k)}
          className="mb-3 customTabs"
        >
          <Tab eventKey="sehat" title="Sehat A - Z">
            <div className="filter_btns">
              {alphabates.map((alphabate, index) => (
                <button
                  type="button"
                  className="filter_btn"
                  onClick={executeScrollForLetter}
                  key={index}
                >
                  {alphabate}
                </button>
              ))}
            </div>
            <Row>
              <Col md={8}>
                {alphabates.map((letter, index) => {
                  return dictionary.get(letter)?.length > 0 ? (
                    <div className="filterContent" ref={ForLetter} key={index}>
                      <h2 className="filterLetter">
                        {letter.toUpperCase() || ''}
                      </h2>
                      <ul className="filterList">
                        {dictionary.get(letter)?.map((item) => (
                          <li key={item}>
                            <Link to="/">{item || ''}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ) : (
                    ''
                  );
                })}
                <SimpleButton onClick={executeScrollForTop}>
                  <img src={arrowUp} alt="arrowUp" className="arrowUpWhite" />
                  back to top
                </SimpleButton>
              </Col>
              <Col md={4}>
                <div className="add">
                  <h2> Ad Space </h2>
                </div>
              </Col>
            </Row>
          </Tab>
          <Tab eventKey="drugs" title="Drugs A - Z" />
        </Tabs>
      </Container>
    </section>
  );
}

export default TopicsFilter;
